import { useQuery } from "@tanstack/react-query";
import { ApiGetUserContactProfile } from "@/api";
import { useUserStore } from "@/store/useUserStore";

export const USER_CONTACT_PROFILE_QUERY_KEY = ["userContactProfile"] as const;

export function useGetUserContactProfile(enabled: boolean) {
  const { userInfo } = useUserStore();
  return useQuery({
    queryKey: USER_CONTACT_PROFILE_QUERY_KEY,
    queryFn: async () => {
      const res = await ApiGetUserContactProfile();
      return res.data;
    },
    enabled: enabled && !!userInfo?.address,
  });
}
